import { ICON_FIELD, IMAGE } from '../elements/assets'
import { FORM_SETTINGS } from '../elements/formSettings'

export const HERO_WITH_FORM_V2 = `
...on heroWithFormV2_Entry {
  id
  typeHandle

  heading: headingAdvanced {
    html
  }

  quote {
    html
  }

  ${ ICON_FIELD }
  authorName
  authorRole

  ${ IMAGE }

  ${ FORM_SETTINGS }
}`